import { lazy } from 'react';
import {
    CREATE_PERMISSION,
    GROUPS_AUTH,
    READ_PERMISSION,
    UPDATE_PERMISSION,
} from 'src/constants/permissions';
import { PermissionsGuard } from './components';

export const Routes = [
    {
        exact: true,
        path: '/create/group',
        guard: PermissionsGuard,
        roles: {
            permission: GROUPS_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(() => import('src/views/group/GroupCreateView')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: GROUPS_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/groups/:id',
        component: lazy(() => import('src/views/group/GroupDetailsView')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: GROUPS_AUTH,
            crud: UPDATE_PERMISSION,
        },
        path: '/management/groups/:id/edit',
        component: lazy(() => import('src/views/group/GroupEditView')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: GROUPS_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/groups',
        component: lazy(() => import('src/views/group/GroupListView')),
    },
];
